package com.evoapps.evoshift.data.dto.auth

import kotlinx.serialization.Serializable

@Serializable
data class SensitiveGeneralDto(
    val email: String? = null,
    val phoneNumber: String? = null,
    val address: String? = null,
    val bankAccountNumber: String? = null,

    // Flaga pomocnicza dla Security Rules (żeby Manager widział dane Shadow Usera)
    val isShadow: Boolean = false
)

// To jest DTO reprezentujące dokument: users/{uid}/sensitive/{workplaceId}
@Serializable
data class SensitiveWorkplaceDto(
    val contractTypeId: String? = null,
    val declared_number_of_hours: Int? = null,
    val compensation: CompensationDto? = null,
    val payrollProfile: PayrollProfileDto? = null,
    /** SH-57: the day ("YYYY-MM-DD") [compensation] applies from; absent: from the start. */
    val compensationEffectiveFrom: String? = null,
    /** SH-57: the earlier pay terms, each from its day; absent in older documents. */
    val rateHistory: List<RatePeriodDto> = emptyList(),
    /** SH-117: the number in the payroll software / RCP card (read by functions/accountantExport.js). */
    val payrollId: String? = null,
    /** SH-149: the day ("YYYY-MM-DD") [payrollProfile] applies from; absent: from the start. */
    val payrollProfileEffectiveFrom: String? = null,
    /** SH-149: the earlier payroll facts, each from its day; absent in older documents. */
    val profileHistory: List<ProfilePeriodDto> = emptyList(),
    /** SH-212: the day ("YYYY-MM-DD") [contractTypeId] and [declared_number_of_hours] apply from; absent: from the start. */
    val contractEffectiveFrom: String? = null,
    /** SH-212: the other contracts, each from its day; absent in older documents. */
    val contractHistory: List<ContractPeriodDto> = emptyList()
)

/** SH-212: a contract that applied from [effectiveFrom] ("YYYY-MM-DD"; "" = from the start). */
@Serializable
data class ContractPeriodDto(
    val effectiveFrom: String = "",
    val contractTypeId: String? = null,
    val declared_number_of_hours: Int? = null
)

/** SH-149: payroll facts that applied from [effectiveFrom] ("YYYY-MM-DD"; "" = from the start). */
@Serializable
data class ProfilePeriodDto(
    val effectiveFrom: String = "",
    val profile: PayrollProfileDto = PayrollProfileDto()
)

/** SH-57: pay terms that applied from [effectiveFrom] ("YYYY-MM-DD"; "" = from the start). */
@Serializable
data class RatePeriodDto(
    val effectiveFrom: String = "",
    val compensation: CompensationDto
)

@Serializable
data class PayrollProfileDto(
    val under26: Boolean = false,
    val student: Boolean = false,
    val taxReliefRequested: Boolean = true,
    val commutes: Boolean = false,
    val voluntarySickness: Boolean = false,
    val insuredElsewhereAtMinimumWage: Boolean = false,
    // SH-57
    val over50: Boolean = false,
    val longService: Boolean = false,
    val ppk: Boolean = false,
    val ppkReducedRate: Boolean = false,
    // SH-149: the last day of a status with a known end ("YYYY-MM-DD"); absent: none.
    val under26Until: String? = null,
    val studentUntil: String? = null
)

// Płaska struktura wynagrodzenia dla bazy danych
@Serializable
data class CompensationDto(
    val type: CompensationType, // ENUM: decyduje, które pola czytać

    // Pola dla HOURLY
    val hourlyRate: Double? = null,

    // Pola dla MONTHLY
    val monthlyBaseSalary: Double? = null,
    val fte: Double? = null,

    // Wspólne
    val employerCost: Double,
    val currency: String = "PLN"
)

@Serializable
enum class CompensationType {
    HOURLY,
    MONTHLY_FIXED
}